// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"9c7d6fc3","213":"59a5f06f","277":"df7b5302","284":"2ff520d7","424":"31d80d27","626":"491d2f30","732":"3c5aff01"}[chunkId] + ".chunk.js";
};